import { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import ContactAgentModal from 'components/modal/ContactAgentModal';
import StyledDiv from 'components/styled/StyledDiv';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function SpeakToYourAgentCardShort({
  styles = '',
  type = 'booking',
  context,
}) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  const { agent = {} } = useSelector((state) => state.currentUser);
  const agentFirstName = agent?.fullName?.split?.(' ')?.[0] || '';
  const [openModal, setOpenModal] = useState(false);

  const openModalHandler = () => {
    setOpenModal(!openModal);
  };

  const customStyles = `
    border-radius: 0.5rem;
    background: ${primaryColour || DEFAULT_PRIMARY_COLOUR};
    margin-top: 40px;

    div.agent-container {
      max-width: 330px;
      margin: auto;
    }

    ${styles}
  `;

  return (
    <>
      <StyledDiv customStyles={customStyles}>
        <div className="p-5 agent-container">
          <div className="text-white xs:text-center lg:text-left">
            <div className="font-medium text-[24px]">
              Message Customer Services
            </div>
            <div className="mt-2">
              Need to ask a question about your{' '}
              {type === 'quote' ? 'quote' : 'booking'}?
            </div>
          </div>
          <div className="mt-7 flex gap-3 xs:justify-center">
            <Button
              label={`Message ${agentFirstName}`}
              className="mx-2 grow xs:grow-0 md:px-4 lg:grow w-full"
              onClick={openModalHandler}
              secondary
            />
          </div>
        </div>
      </StyledDiv>
      <ContactAgentModal
        assignee={agent}
        openModal={openModal}
        setOpenModal={setOpenModal}
        context={context}
      />
    </>
  );
}
